export default __webpack_public_path__ + "static/media/EST.5cc60c3a.svg";